<div class="display-flex align-items-centered flex-col">
  <div class="headding h1 text-center margin-t-xl">Welcome to Projects Dashboard</div>

  <div class="search-container display-flex align-items-centered margin-t-l margin-b-l w-50">
    <span style="width:40px" class="border-right display-flex align-items-centered justify-center" ><mat-icon class="icon-color">search</mat-icon></span>
    <input type="search" class="search-without-border" placeholder="Search By Project Name"  />
  </div>
  <div class="display-flex align-items-centered margin-l text-center">
    <div class="project-card padding-xl clickable margin-l">
      <div class="bold margin-b-l large-font">Project Name</div>
      <div class=""> <span>Project Date Start </span> - <span>Project Date End </span></div>
    </div>
    <div class="project-card padding-xl clickable margin-l">
      <div class="bold margin-b-l large-font">Project Name</div>
      <div class=""> <span>Project Date Start </span> - <span>Project Date End </span></div>
    </div>
  </div>
</div>
